import { post, get, req } from '@/plugins/axios'
import { res } from './login'

/**
* 查询平台订单分页（前台） 我的物料
* @param {Object} data
*/
export function getStockList(data: any) {
  return post('/order/customer/shop/ingredients/page', data)
}

/**
 *
 * @param shopProductSkus
 * @returns
 */
export function getBatchStock(shopProductSkus: string[]) {
  return post('/order/cart/batchQueryStock', { shopProductSkus })
}
/**
* 分页我的商品库存
* @param {Object} data
*/
export function getProductList(data: any) {
  return post('/order/shop/product/sku/pageMyInventory', data)
}

/**
* 批量添加辅料至购物车
* @param {Object} data
*/
export function addIngredientsProduct(data: any) {
  return post('/order/cart/addIngredientsProduct', data)
}

/**
* 批量添加辅料至购物车
* @param {Object} data
*/
export function pageMyInventoryList(data: any) {
  return post('/order/shop/product/sku/pageMyInventoryList', data)
}

/**
* 批量添加我的商品至购物车
* @param {Object} data
*/
export function batchAddProduct(data: any) {
  return post('/order/cart/batchAddProduct', data)
}

/**
* 一键绑定亚马逊sku
*/
export function batchBindAmazonSku() {
  return post('/order/shop/product/sku/batchBindAmazonSku')
}

/**
* 次转正分页
*/
export function regularizationPage(data: any) {
  return post('/order/regularization/pageBad', data)
}

/**
* 次品作废
*/
export function regularizationInvalid(data: any) {
  return post('/order/regularization/batchUpdateBecomeInvalid', data)
}

/**
* 次品转正
*/
export function regularizationRegular(data: any) {
  return post('/order/regularization/batchUpdateBecomeRegular', data)
}

/**
* 次转正保存附加项
*/
export function saveReselectBadAddition(data: any) {
  return post('/order/regularization/saveReselectBadAddition', data)
}

/**
* 确认支付次转正附加项
*/
export function confirmPayReselectBadAddition(data: any) {
  return post('/order/regularization/confirmPayReselectBadAddition', data)
}

/**
* 分页我的商品测量结果
* @param {Object} data
*/
export function getMeasureList(data: any) {
  return post('order/measure/page', data)
}

/**
* 组合商品详情
* @param {Object} data
*/
export function getCombinaProductDetailApi(combinationProductSku: string) {
  return post('/order/combination/product/selectByCombinationProductSkuDetail?combinationProductSku=' + combinationProductSku, {})
}

export const getMeasureNewCountApi = (): Promise<res> =>
  get('/order/measure/newCount')

/**
* 获取在途库存接口
* @param {Object} data
*/
export function pageOnTheWayStockApi(data: any) {
  return post('/api/thirdShopItem/pageOnTheWayStock', data)
}
/**
* 获取在途库存是否有
* @param {Object} data
*/
export function hasAvailableTransportationNums(data: any) {
  return post('/api/thirdShopItem/hasAvailableTransportationNums', data)
}

/**
* 更改客户商品规格
* @param {Object} data
*/
export function updateSpecification(data: any) {
  return post('/order/shop/product/sku/updateSpecification', data)
}

/**
* 更改客户商品规格
* @param {Object} data
*/
export function updateSpecificationExcel(data: any) {
  return post('/order/shop/product/sku/importExcel', data)
}

/**
* 更改客户商品规格日志
* @param {Object} data
*/
export function updateStockLog(data: any) {
  return post('/order/shop/product/sku/updateLogList', data)
}

// 辅料不足提醒配置
export const getStockNotifyConfig = (): Promise<res> =>
  get('customer/config/getStockNotifyConfig')

// 辅料不足提醒配置保存
export function saveStockNotifyConfig(data: any) {
  return post('/customer/config/saveStockNotifyConfig', data)
}

// 获取预处理分类
export function getPrepCategoryListApi(data?: any) {
  return post('/api/amazon/product/list', data)
}

// 校验是否是特殊新品测量白名单客户
export function checkVideoWhiteUserApi(params?: any) {
  return req('/wms/measure/checkSizeMeasureCustomer', params)
}

// crossmall商品列表
export function getCrossMallProductListApi(data?: any) {
  return post('/api/crossMall/product/page', data)
}

// 删除crossmall商品列表
export function delCrossMallProductListApi(data?: any) {
  return post('/api/crossMall/product/remove', data)
}

// sku 查询crossmall商品列表
export function getSkuCrossMallProductListApi(data?: any) {
  return post('/api/crossMall/product/getCrossMallProductBySku', data)
}

// 绑定crossmall商品
export function bindCrossMallSkuApi(data?: any) {
  return post('/order/shop/product/sku/bindCrossMallSku', data)
}

// 解绑crossmall商品
export function unbindCrossMallSkuApi(data?: any) {
  return post('/order/shop/product/sku/unbindCrossMallSku', data)
}

// 一键绑定crossmall商品
export function batchBindCrossMallSkuApi(data?: any) {
  return post('/order/shop/product/sku/batchBindCrossMallSku', data)
}
